import ChipCheckMark from 'app/Apps/DomainObject/ComponentMapper/ChipCheckMark'
import {
    Column,
} from 'app/types/simpletable.types'
import getUniqueId from 'app/utils/getUniqueId'

import {
    ContactDuplication,
} from '../Contacts.types'

const columns = ({
    label,
}): Column<keyof ContactDuplication>[] => {
    return [
        {
            fieldName: 'contactName',
            label: label('Contact.contactName'),
            id: getUniqueId(),
        },
        {
            fieldName: 'email',
            label: label('Contact.email'),
            id: getUniqueId(),
        },
        {
            fieldName: 'companyCompanyName',
            label: label('BillingCompanyDto.company'),
            id: getUniqueId(),
        },
        {
            fieldName: 'isProspect',
            label: label('Contact.isProspect'),
            id: getUniqueId(),
            component: ChipCheckMark,
        },
        {
            fieldName: 'archived',
            label: label('Contact.isArchived'),
            id: getUniqueId(),
            component: ChipCheckMark,
        },
    ]
}

export default columns
